const types = {
  SELECT: "select",
  DATE: "date",
  LOCATION: "location",
};

export default types;
